import { render, staticRenderFns } from "./Audiovisual.vue?vue&type=template&id=21c7fb10&"
import script from "./Audiovisual.vue?vue&type=script&lang=js&"
export * from "./Audiovisual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports